/**
 * GradePreset type:
 * {
 *   tint: { r, g, b, a },   // a is strength
 *   brightness: number,       // 0.95..1.05
 *   contrast: number,         // 0.95..1.05
 *   saturation: number,       // 0.90..1.05
 *   vignette: { strength, radius },  // radius 0..1
 * }
 */

export const PRESETS = {
  dawn: {
    tint: { r: 255, g: 180, b: 120, a: 0.08 },
    brightness: 0.97,
    contrast: 0.97,
    saturation: 0.95,
    vignette: { strength: 0.15, radius: 0.7 },
  },
  noon: {
    tint: { r: 255, g: 250, b: 240, a: 0.02 },
    brightness: 1.03,
    contrast: 1.0,
    saturation: 1.02,
    vignette: { strength: 0.05, radius: 0.85 },
  },
  sunset: {
    tint: { r: 255, g: 140, b: 80, a: 0.10 },
    brightness: 0.96,
    contrast: 0.98,
    saturation: 0.98,
    vignette: { strength: 0.20, radius: 0.65 },
  },
  night: {
    tint: { r: 60, g: 80, b: 160, a: 0.12 },
    brightness: 0.90,
    contrast: 0.96,
    saturation: 0.85,
    vignette: { strength: 0.30, radius: 0.55 },
  },
};

/** Linearly interpolate between two presets by factor t (0..1). */
export function lerpPreset(a, b, t) {
  const l = (x, y) => x + (y - x) * t;
  return {
    tint: {
      r: l(a.tint.r, b.tint.r),
      g: l(a.tint.g, b.tint.g),
      b: l(a.tint.b, b.tint.b),
      a: l(a.tint.a, b.tint.a),
    },
    brightness: l(a.brightness, b.brightness),
    contrast: l(a.contrast, b.contrast),
    saturation: l(a.saturation, b.saturation),
    vignette: {
      strength: l(a.vignette.strength, b.vignette.strength),
      radius: l(a.vignette.radius, b.vignette.radius),
    },
  };
}
